import { useContext, useEffect, useRef, useState } from 'react';
import './siteContentsComponents.css'
import { Box, Typography } from '@mui/material';
import Card from '../card/Card';
import RichEditorSiteContents from './richEditorSiteContents/RichEditorSiteContents';
import ButtonEditor from './ButtonEditor';
import MediaEditor from './MediaEditor';
import TitleEditor from './TitleEditor';

export default function BannerServiceEditor({data, isBannerService, dataParent, setTitleParent}) {

    return (
        <Card className="flex col center">
            <Box className="siteContents-cardSection flex w100 aicenter">
                <TitleEditor data={data} required isBannerService={isBannerService} dataGrandpa={dataParent} setTitleGrandpa={setTitleParent}/>
                {data.type !== "sectionFindAJob" && <MediaEditor data={data}/>} 
                <Box className="siteContents-item flex col w100">
                    <Typography variant="body2" component="span" sx={{mr:1}} className="Montserrat tbold">
                        Short description
                    </Typography>
                    <Box className="siteContents-data flex col aicenter w100" sx={{background:"var(--gray)",py:0.5}}>    
                        <RichEditorSiteContents onlyText data={data}/>
                    </Box>
                </Box>
                {data.type !== "sectionFindAJob" && <ButtonEditor data={data}/>}    
            </Box>
        </Card>     
    );
}